<ng-container *ngIf="!isLoading; else loadingTemplate">

<div class="dash-wrap">
  <div class="topbar">
    <div class="title">
      <h1>Admin Dashboard</h1>
      <p class="subtitle">Welcome back! Here’s what’s happening with Bipperz.</p>
    </div>
  </div>

  <div class="stats-grid">
    <mat-card class="stat-card">
      <div class="stat-left">
        <div class="stat-label">Total Users</div>
        <div class="stat-value">{{ totalUsers() | number }}</div>
      </div>
    </mat-card>

    <mat-card class="stat-card">
      <div class="stat-left">
        <div class="stat-label">Total Companies</div>
        <div class="stat-value">{{ totalCompanies() | number }}</div>
      </div>
    </mat-card>
  </div>

  <mat-card class="chart-card">
    <div class="chart-header">
      <div>
        <h3>User Signups</h3>
        <small>Daily user registration trend</small>
      </div>
    </div>

    <div class="chart-area">
      <canvas #usersGrowthCanvas></canvas>
    </div>
  </mat-card>

</div>
</ng-container>
<ng-template #loadingTemplate>
  <app-load-mask></app-load-mask>
</ng-template>
